export default __webpack_public_path__ + "static/media/480_dummy2016-meditation01-mobile-de.f6528883.png";